import DefaultNotification from "./DefaultNotification";

class InfoNotification extends DefaultNotification {
    type = "info";
}

export default InfoNotification;